class LoginPage extends HTMLElement {
  constructor() {
    super();
    this.initEventListener();
  }

  initEventListener() {
    document.querySelectorAll(".customer__show-password").forEach((button) => {
      button.addEventListener("click", this.seePassWord.bind(this));
    });

    document
      .querySelector(".customer_recover ")
      .addEventListener("click", this.showRecoverForm.bind(this));
    document
      .querySelector(".customer__recover-cancel ")
      .addEventListener("click", this.hideRecoverForm.bind(this));
  }

  seePassWord(e) {
    if (
      e.currentTarget.parentNode
        .querySelector(".password")
        .getAttribute("type") === "text"
    ) {
      e.currentTarget.parentNode
        .querySelector(".password")
        .setAttribute("type", "password");
    } else {
      e.currentTarget.parentNode
        .querySelector(".password")
        .setAttribute("type", "text");
    }
    e.currentTarget.parentNode
      .querySelector(".customer__password-hide")
      .classList.toggle("hidden");
    e.currentTarget.parentNode
      .querySelector(".customer__password-show")
      .classList.toggle("hidden");
  }

  showRecoverForm(e) {
    this.querySelector(".recover-password").classList.remove("hidden");
    this.querySelector(".login > .customer__big-title").classList.add("hidden");
    this.querySelector(".customer__login").classList.add("hidden");
  }

  hideRecoverForm(e) {
    this.querySelector(".recover-password").classList.add("hidden");
    this.querySelector(".login > .customer__big-title").classList.remove(
      "hidden"
    );
    this.querySelector(".customer__login").classList.remove("hidden");
  }
}

customElements.define("login-page", LoginPage);

class AdressePage extends HTMLElement {
  constructor() {
    super();
    this.currentEditAddress = "";

    this.querySelectorAll(".edit-address-button").forEach((button) => {
      button.addEventListener("click", this.editAddress.bind(this));
    });

    this.querySelector(".customer__add-address").addEventListener(
      "click",
      this.showAddAddressForm.bind(this)
    );
    this.querySelector(".customer__cancel-address").addEventListener(
      "click",
      this.hideAddAddressForm.bind(this)
    );
  }

  showAddAddressForm(e) {
    this.querySelector(".customer_address").classList.toggle(
      "customer_address__open"
    );
  }

  hideAddAddressForm(e) {
    this.querySelector(".customer_address").classList.remove(
      "customer_address__open"
    );
  }

  editAddress(e) {
    document.querySelectorAll(".customer_address__open").forEach((address) => {
      address.classList.remove("customer_address__open");
    });

    this.currentEditAddress = e.currentTarget.getAttribute("data-address-id");
    console.log(this.currentEditAddress);

    this.querySelector(`#EditAddress_${this.currentEditAddress}`).classList.add(
      "customer_address__open"
    );
    this.querySelector(`#EditAddress_${this.currentEditAddress}`)
      .querySelector(".edit-cancel_button")
      .addEventListener("click", function () {
        document
          .querySelector(`.customer_address__open`)
          .classList.remove("customer_address__open");
      });
  }
}

customElements.define("adresse-page", AdressePage);

class AccountUpdate extends HTMLElement {
  constructor() {
    super();

    this.querySelector(".customer-account__form-container").addEventListener(
      "submit",
      this.submitUpdateForm.bind(this)
    );

    this.querySelector(".customer-form__sms-checkbox").addEventListener(
      "click",
      this.toogleCheckbox.bind(this)
    );
    this.querySelector(".customer-form__newsletter-checkbox").addEventListener(
      "click",
      this.toogleCheckbox.bind(this)
    );

    this.getCustomerData();

    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("focus", function () {
        this.classList.remove("error");
      });
    });
  }

  getCustomerData() {
    let url =
      "https://mem72unxg6.execute-api.eu-west-3.amazonaws.com/prod/customers/{id}";
    url = url.replace("{id}", window.CUSTOMER_ID);
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        let sms_subscribe =
          data.customer.sms_marketing_consent.state == "subscribed"
            ? true
            : false;
        document.getElementById("sms").checked = sms_subscribe;
      });
  }

  submitUpdateForm(e) {
    e.preventDefault();
    const form = e.currentTarget;

    const civilite = form.querySelector('input[name="civilite"]:checked').value;

    const firstName = document.getElementById("RegisterForm-FirstName").value;
    const lastName = document.getElementById("RegisterForm-LastName").value;
    const birthday = document.getElementById("date-input").value;
    const language = document.getElementById("langue").value;
    const newsletter = document.getElementById("newsletter").checked;
    const accepts_sms = document.getElementById("sms").checked;
    const phone = document.querySelector('[name="customer[phone]"]').value;

    const data = {
      customer: {
        first_name: firstName,
        last_name: lastName,
        accepts_marketing: newsletter,
        birthday: birthday,
        accepts_sms: accepts_sms,
        language: language,
        civilite: civilite,
        phone: phoneInput.getNumber()
      },
    };

    let verification_passed = this.verifyData(data);

    if (verification_passed) {
      fetch(
        `https://mem72unxg6.execute-api.eu-west-3.amazonaws.com/prod/customers/${window.CUSTOMER_ID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => {
          console.log(response.json());
          if (response.ok) {
            location.reload();
          } else {
            // Affichage d'un message d'erreur si la mise à jour a échoué
            alert(
              "Une erreur est survenue lors de la mise à jour de vos données."
            );
          }
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          // Affichage d'un message d'erreur si une erreur s'est produite pendant l'envoi des données
          alert(
            "Une erreur est survenue lors de l'envoi des données : " +
              error.message
          );
        });
    }
  }

  toogleCheckbox(e) {
    const checkbox = e.currentTarget.querySelector(".customer-form-checkbox");

    if (checkbox.checked === true) {
      checkbox.checked = false;
    } else {
      checkbox.checked = true;
    }
  }

  verifyData(data) {
    let verification_passed = true;

    if (data.customer.first_name === "") {
      verification_passed = false;
      document.getElementById("RegisterForm-FirstName").classList.add("error");
    } else {
      document
        .getElementById("RegisterForm-FirstName")
        .classList.remove("error");
    }

    if (data.customer.last_name === "") {
      verification_passed = false;
      document.getElementById("RegisterForm-LastName").classList.add("error");
    } else {
      document
        .getElementById("RegisterForm-LastName")
        .classList.remove("error");
    }

    if (data.customer.birthday === "") {
      verification_passed = false;
      document.getElementById("date-input").classList.add("error");
    } else {
      document.getElementById("date-input").classList.remove("error");
    }

    let phone = phoneInput.getNumber();

    if (phone === "") {
      verification_passed = false;
      document.querySelector('[name="customer[phone]"]').classList.add("error");
    } else {
      let re =
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
      let ok = re.exec(phone);

      if (!ok) {
        verification_passed = false;
        document
          .querySelector('[name="customer[phone]"]')
          .classList.add("error");
      } else {
        document
          .querySelector('[name="customer[phone]"]')
          .classList.remove("error");
      }
    }

    return verification_passed;
  }
}

customElements.define("account-update", AccountUpdate);
